import * as Scrivito from "scrivito"

export const AccordionWidget = Scrivito.provideWidgetClass("AccordionWidget", {
  attributes: {
    tabs: ["widgetlist", { only: "TabWidget" }]
  }
})

export type AccordionWidgetObj = InstanceType<typeof AccordionWidget>
